import React, { useEffect } from 'react';
import { Layout, AdBlock, AdImage } from '../../components';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import "./InformacionParaPrestadores.scss";

const InformacionParaPrestadores = () => {

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    return (
        <Layout background="#1f2024">
            <div className="how-to-users">
                <div className="how-to-users__container">
                    <div className="how-to-users__content">
                        <h2 className="how-to-users__content--title">Información para prestadores?</h2>

                        <h4>¿Cómo funciona Solucionarte?</h4>
                        <ul>
                            <li>Completas el proceso de registro y perfeccionas tu perfil.</li>
                            <li>Navegas las consultas disponibles.</li>
                            <li>Aceptas las que te parezcan interesantes.</li>
                            <li>Envías una propuesta y comunicas con el usuario.</li>
                            <li>El usuario elegirá con quién o quiénes trabajar.</li>
                            <li>En caso de ser contratado ¡no olvides pedir que te califiquen!</li>
                        </ul>

                        <h3>Preguntas precuentes</h3>

                        <h4>¿Qué es una Consulta?</h4>
                        <p>Una consulta es un pedido de presupuesto cargado por un usuario. En una consulta, el usuario detalla qué trabajo debe resolver.  Se te avisará por email cuando tengas una nueva consulta disponible, o bien puedes acceder a la plataforma y revisar otras consultas disponibles. Puedes aceptarla y enviar una propuesta al cliente, lo que te descontará créditos o bien puedes rechazarla indicando el motivo para que el sistema con el tiempo aprenda qué tipo de trabajos te interesan.</p>

                        <h4>¿Que pasa si el cliente no contesta?</h4>
                        <p>En caso que la propuesta enviada inicial haya sido leída o el cliente haya provisto un contacto telefonico, es decisión consciente del cliente contestar, o bien del prestador decidir llamar telefónicamente. Por lo tanto no hay devolución de créditos.

                            En caso de que el cliente no haya consignado teléfono, ni haya leído tu respuesta, se devuelven los créditos en el transcurso de dos semanas de enviada la propuesta inicial.</p>

                        <h4>¿Que puedo hacer como prestador Solucionarte?</h4>
                        <p>Una vez que tu perfil está completo, tu cuenta activada y cuentes con un plan, puedes</p>

                        <ul>
                            <li>Recibir consultas de manera constante, entre las que podrás elegir en cuales participar y en cuales no, para presupuestar y ser contratado de manera directa.</li>
                            <li>Contar con un perfil online visible a toda persona que te busque a través de Google.</li>
                            <li>Utilizar las herramientas digitales como ser: Modelo de presupuesto, Emisión de Curriculum, Tarjetas personales, Modelo de recibo, etc.</li>
                            <li>Desarrollar una reputación online que puedes enviar como referencia a tus clientes por fuera de la plataforma.</li>
                            <li>Obtener sellos profesionales que respalden tu profesionalismo</li>
                            <li>Aprovechar los descuentos y promociones que se van incorporando a la sección Beneficios.</li>
                            <li></li>
                        </ul>
                    </div>

                    <div className="how-to-users__ads">
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>

                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default InformacionParaPrestadores;
